import { IS_DEV } from "@/config/constants";
import SiegeSystemRepository from "@/game/SiegeSystemRepository";
import type TileRepository from "@/game/TileRepository";

let ssr: SiegeSystemRepository | null = null;

export const createSiegeSystemRepository = (
	tilerepo: TileRepository,
): SiegeSystemRepository => {
	if (ssr) throw new Error("SiegeSystemRepository already initialized");

	ssr = new SiegeSystemRepository(tilerepo);

	// @ts-expect-error - missing type in window
	if (!window.ssr && IS_DEV) window.ssr = ssr;

	return ssr;
};

export default (): SiegeSystemRepository => {
	if (!ssr) throw new Error("SiegeSystemRepository not initialized");
	return ssr;
};

export const isSiegeSystemRepositoryInitialized = (): boolean => ssr !== null;
